module.exports = __webpack_public_path__ + "static/img/icon-hotel-type4.98c5d25b.png";